namespace GeniuzPOS.Inventory {
    export enum BacPostFgStatus {
        bUnPost = 0,
        bPosted = 1,
        binpro = 2
    }
    Serenity.Decorators.registerEnumType(BacPostFgStatus, 'GeniuzPOS.Inventory.BacPostFgStatus');
}
